import React from 'react'

import {
  AlignItems,
  BorderStyle,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontWeight,
  Icon,
  IconVariant,
  JustifyContent,
  Text,
  ZIndex,
} from '@gousto-internal/citrus-react'

type FlexEducationTooltipProps = {
  onClose: () => void
}

export const FlexEducationTooltip = ({ onClose }: FlexEducationTooltipProps) => {
  const handleClose = (event: React.SyntheticEvent) => {
    event.stopPropagation()
    onClose()
  }
  const stopPropagation = (event: React.SyntheticEvent) => {
    event.stopPropagation()
  }

  return (
    <Box
      data-testid="flex-education-tooltip"
      position={DisplayPosition.Absolute}
      bottom="calc(100% + 4px)"
      right="0"
      zIndex={ZIndex.Mask}
      onClick={stopPropagation}
      onKeyDown={stopPropagation}
      onKeyPress={stopPropagation}
      onKeyUp={stopPropagation}
      style={{
        pointerEvents: 'auto',
        width: 'min(380px, 100%)',
      }}
    >
      <Box
        position={DisplayPosition.Absolute}
        bottom="-12px"
        right="12px"
        color={Color.ColdGrey_900}
        style={{
          borderLeft: '12px solid transparent',
          borderRight: '12px solid transparent',
          borderTop: '18px solid currentColor',
          height: 0,
          width: 0,
        }}
      />
      <Box
        width="100%"
        bg={Color.ColdGrey_900}
        paddingV={3}
        paddingH={3}
        borderRadius={1.5}
        borderStyle={BorderStyle.Solid}
        color={Color.White}
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.FlexStart}
      >
        <Box
          width="100%"
          display={Display.Flex}
          alignItems={AlignItems.Center}
          justifyContent={JustifyContent.SpaceBetween}
          paddingBottom={2}
        >
          <Text size={3} fontWeight={FontWeight.Bold}>
            Flex your recipe portions here
          </Text>
          <button
            type="button"
            aria-label="Close flex education tooltip"
            onClick={handleClose}
            onKeyDown={stopPropagation}
            onKeyPress={stopPropagation}
            onKeyUp={stopPropagation}
            style={{
              alignItems: 'center',
              background: 'transparent',
              border: 0,
              color: 'inherit',
              cursor: 'pointer',
              display: 'flex',
              flexShrink: 0,
              lineHeight: 0,
              padding: 0,
            }}
          >
            <Icon name="close" variant={IconVariant.Inherit} />
          </button>
        </Box>
        <Text color={Color.White} size={1}>
          You can edit the portions in your recipe if you have a different amount of people eating
          that meal.
        </Text>
      </Box>
    </Box>
  )
}
